import * as messageService from '@/services/messageCenter';

export default {
  namespace: 'MessageManager_message',

  state: {
    data: {},
  },

  effects: {
    *setAllRead({ payload }, { call, put }) {
      const { status, data } = yield call(messageService.setAllRead, payload);
    },

    *setRead({ payload }, { call, put }) {
      const { status, data } = yield call(messageService.setRead, payload);
    },

    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(
        messageService.fetchMessages,
        payload
      );

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
